import clsx from "clsx";
import type { ComponentPropsWithoutRef, ElementType } from "react";

export type ButtonProps<C extends ElementType> = {
  as?: C;
  disabled?: boolean;
} & ComponentPropsWithoutRef<C | "button">;

const Button = <C extends ElementType>({
  children,
  className,
  disabled = false,
  as,
  ...props
}: ButtonProps<C>) => {
  const Component = as || "button";

  return (
    <Component
      {...props}
      className={clsx(
        "rounded-lg py-2 text-center font-semibold text-variantTextColor",
        disabled ? "cursor-not-allowed bg-secondTextColor" : "bg-buttonColor",
        className,
      )}
      disabled={disabled}
    >
      {children}
    </Component>
  );
};

export default Button;
